const Form033EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },
    noteList: {
        title1: "Important Announcement:",
        title2: "Reference Materials:",
        note1: "The exchange rate to be used for the purpose of reimbursement is the mid-market rate as at the first working day of the month in which the passage begins.  For seeking reimbursement before the homeward travel, the mid-market rate as at the first working day of the month in which the claim is submitted would be used.",
        note2: "The quotation of flight tickets should be arranged by the School. Schools ought to assign clear segregation of staff duties at different stages of the procurement process to ensure openness and fairness.",
        note3: "EDB Circular Nos. {{pnetNum}} (NET Scheme in Primary Schools)",
        // note3: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/EDBC09008E.pdf",
        note4: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/Fringe%20Benefit_aug%202022/Fringe%20Benefit_August%202022_updated/EDBC09008E_082022.pdf",
        note5: "EDB Circular Nos. {{netNum}} (Enhanced NET Scheme in Secondary Schools)",
        // note5: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/EDBC09009E.pdf",
        note6: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/Fringe%20Benefit_aug%202022/Fringe%20Benefit_August%202022_updated/EDBC09009E_082022_R.pdf",
        note7: "“Sample Memorandum on the Terms and Conditions of Service for Appointment as Teachers under the NET Scheme in Primary Schools / the Enhanced NET Scheme in Secondary Schools (applicable to {{schoolYear}} school year)”",
        note8: "Primary Schools:",
        note9: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/MOCS_201920_Primary%20Schools.pdf",
        note10: "Secondary Schools:",
        note11: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/MOCS_201920_Secondary%20Schools.pdf",
        number1: "1.",
        number2: "2.",
        number3: "3.",
        number4: "4.",
        number5: "5.",
        number6: "6.",
        numbera: "(a)",
        numberb: "(b)",
        numberc: "(c)",
        numberd: "(d)",
    },
    label: {
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        partI: "PART I (To be completed by the NET)",
        aidedOrCaput: "School Type",
        textBeforeSchoolName: "To: Supervisor/Principal of",
        textAfterSchoolName: "(School)",
        schoolName: "school name",
        sec1: "Particulars of NET and family members",
        name: "name",
        nameInFull: "Name in full",
        dateOfBirth: "Date of birth",
        ddmmyyyy: "(dd/mm/yyyy)",
        myself: "Myself",
        mySpouse: "My spouse",
        myChild: "My child(ren) who is/are unmarried and under the age of 18",
        child: "child",
        sec2: "I hereby apply for reimbursement of SINGLE passage and submit the receipt(s) /and boarding pass(es) for reimbursement of air fares as shown below.",
        destination: "destination",
        destinationsDeclared: "Destinations declared for this application: ",
        from: "From",
        to: "to",
        fullStop: ".",
        secTable: "Air passage taken/to be taken and amount claimed for:",
        directOrIndirect: "Direct/indirect route",
        commencementDate: "Commencement of the journey on",
        completionDate: "Completion of the journey on",
        noteStar:
            "The actual expenses are the actual costs of the air tickets including airport tax as shown on the receipt, net of any other expenses such as accommodation.",
        actualExpenses: "Actual expenses",
        star: "**",
        noteHash:
            "If the applicant is entitled only for single passage(s) but bought return ticket(s), the amount claimed should be 50% of the airfare.",
        hash: "#",
        amountClaimed: "Amount claimed",
        note: "In case different currencies are involved, please fill in the total sum with indication of figures in different currencies e.g. HK$2,000+US$150.",
        total: "TOTAL",
        sec3: "I hereby apply for reimbursement of RETURN passage and submit the receipt(s) /and boarding pass(es) for reimbursement of air fares as shown below.",
        between: "Between",
        and: "and",
        close: "Close",
        textBeforeSec4:
            "I hereby apply for reimbursement of baggage allowance and submit the receipts/invoice of my baggage expenses at a total of",
        textAfterSec4: "(please specify the currency).",
        textAfterSec1: "(please specify the currency)",
        currency: "currency",
        underline: "______________",
        sec5MySpouse: "Full name of my spouse",
        hkidMySpouse: "Hong Kong Identity Card Number (if any)",
        textBeforeSec5Declare:
            "I declare that my spouse of particulars stated above",
        textAfterSec5Declare: "employed under the Enhanced NET Scheme in ",
        textAfterSec5Declare2:
            "Secondary Schools or the NET Scheme in Primary Schools. If the answer is in the affirmative, please provide the employment details of your spouse as specified below:",
        schoolNameMySpouse: "Name of school",
        contractPeriodFrom: "Contract period: from",
        contractPeriodTo: "to",
        sec6Text1:
            "I declare that I and my family members are eligible for the",
        sec6Text2: "/",
        sec6Text2Temp: "and",
        sec6Text3:
            "* allowance claimed and that I and my family are not receiving any double",
        sec6Text4:
            "* benefit arising from my employment with the school and my spouse’s employment. I undertake to notify the school at once should there be any subsequent change to this information.",
        passage: "passage",
        baggage: "baggage",
        textBeforeSec7:
            "I confirm that I have read and understood the EDB Circular No.",
        sec7Primary:
            "{{pnetNum}} including the Notes for Completing PNET-Forms",
        sec7Secondary:
            "{{netNum}} including the Notes for Completing NET-Forms",
        textAfterSec7:
            "A-E and the stipulations related to passage allowance and baggage allowance in the Memorandum on the Terms and Conditions of Service.",
        hkid: "Hong Kong Identity Card Number (Mandatory to be provided once available)",
        fullNameOfNET: "Full name of NET",
        givenName: "(Given names)",
        surname: "(Surname)",
        partII: "PART II (To be completed by aided schools/special schools)",
        partIITo: "To:",
        address1: "Secretary for Education",
        address2: "[Attn: NET Administration Team, Education Bureau]",
        address3: "Room W304, 3/F, West Block",
        address4: "Education Bureau Kowloon Tong Education Services Centre",
        address5: "19 Suffolk Road, Kowloon Tong, Kowloon",
        partIICertify: "I certify that the applicant is:",
        selectSchoolType: "Please select the school type",
        textBeforeDate1: "appointed as a Native-speaking English Teacher under",
        textBeforeDate2: "in my school from",
        textBeforePreviousContractDate:
            "(For the contract renewed/appointment contract period extended, the previous appointment/extension contract period was from",
        textAfterPreviousContractDate: "); and",
        netSchemePrimaryOrSecondary:
            "the NET Scheme in Primary Schools / the Enhanced NET Scheme in Secondary Schools",
        netSchemePrimary: "the NET Scheme in Primary Schools",
        netSchemeSecondary: "the Enhanced NET Scheme in Secondary Schools",
        eligibleGrant: "eligible for the grant of the following:",
        para2: "Details of the passage(s) and amount of allowance claimed as shown in Part I para. 2/para. 3 above have been checked and found correct.",
        quotation:
            "Quotation of economy class air passage by the most direct route obtained by the school:",
        nameOfAirline: "Name of Airline",
        teacher: "Teacher",
        teacherSpouse: "Teacher's spouse",
        teacherChild: "Teacher's child(ren)",
        passageQuoted: "Passage quoted",
        quotedPrice: "Quoted price",
        hkDollar: "HK$",
        amountAllowanceApproved: "Amount of passage allowance approved:",
        passageEntitled: "Passage entitled",
        amountApproved: "Amount approved",
        noteAt: "The amount approved should be the amount claimed by the applicant in Part I which has been checked and duly corrected by the school, or the quoted price shown above, whichever is the less.",
        para3: "I certify that the applicant is entitled to an in-bound to Hong Kong baggage allowance at the",
        amountReimbursed: "rate. The amount to be reimbursed is ",
        specifyCurrency: " (please specify the currency).",
        partIII: "PART III (To be completed and retained by caput schools)",
        partIVTitle: "PART IV (To be completed by School Principal/Supervisor)",
        amount: "amount",
        para4: "I certify that the applicant is entitled to an out-bound to country of origin baggage allowance at the",
        para5Bold:
            "I certify that relevant receipt(s)/invoice(s)/boarding pass(es) have been sighted by me and are kept in the school for record purpose. ",
        para5: "I should be grateful if you would arrange the payment.",
        nameOf: "Name of",
        supervisorOrPrincipal: "supervisor/principal",
        nameOfSchool: "Name of school",
        schoolCode: "School code",
        schoolAddress: "School address",
        faxNo: "Fax no.",
        contactPerson: "Contact person for enquiry",
        telNo: "Tel. no.",
        postOfContactPerson: "Post of contact person",
        partIIIApproved: "The grant of the following is approved:",
        partIV: "Part IV",
        textBeforePartIV: "I confirm that",
        textAfterPartIV:
            "(Full name of the NET) has already established that his/her normal place of residence as outside Hong Kong and he/she is entitled to receive the Passage/Baggage Allowance (please specify currency if not in Hong Kong Dollar) as follows:",

        part2b_1:
            "nos. of quotation(s) of economy class air passage by the most direct route have been obtained by the school on ",
        part2b_2: "(date)",
        part2b_3: "Quotation information is attached",
    },

    formContent: {
        primaryOrSecondaryOption: {
            primary:
                "Native-speaking English Teacher (NET) Scheme in Primary Schools Application for Reimbursement of Passage/Baggage Allowance",
            secondary:
                "Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools Application for Reimbursement of Passage/Baggage Allowance",
        },
        directOrIndirectOption: {
            direct: "direct",
            indirect: "indirect",
        },
        sec4Option: {
            A: "In-bound to Hong Kong baggage allowance<br>I declare that this baggage claim is made upon my first appointment under the NET Schemes and I understand that no baggage allowance will be provided for any subsequent appointment under the NET Schemes.",
            B: "Out-bound to country of origin baggage allowance<br>I declare that this baggage claim is made upon completion of an appointment under the NET Schemes, be it the first appointment or any subsequent appointment under the NET Schemes, and I will not be in another employment with schools falling under the Schemes’ purview (i.e. {{school}}).",
        },
        sec5Option: {
            single: "I am single.",
            married:
                "I am married and my spouse’ particulars are provided as follows:",
        },
        isOrNotOption: {
            is: "is",
            not: "is not",
        },
        aidedOrCaputOption: {
            aided: "Aided schools / Special school",
            caput: "Caput school",
        },
        eligibleGrantOption: {
            passageAllowance:
                "passage allowance [please complete para. 2 below]",
            inBound:
                "in-bound to Hong Kong baggage allowance [please complete para. 3 below]",
            outBound:
                "out-bound to country of origin baggage allowance [please complete para. 4 below]",
        },
        singleOrReturnOption: {
            single: "single",
            return: "return",
        },
        singleOrMarriedOption: {
            single: "single",
            married: "married",
        },
        supervisorOrPrincipalOption: {
            supervisor: "supervisor",
            principal: "principal",
        },
        titleOption: {
            Mr: "Mr.",
            Mrs: "Mrs.",
            Ms: "Ms.",
            Miss: "Miss.",
        },
    },
    errorMsg: {
        under18: "This child should be under age of 18",
        completionDateSingle:
            "Please select a date before completion of the journey of single passage",
        completionDateReturn:
            "Please select a date before completion of the journey of return passage",
        schoolCode: "School code must be exactly 4 digits",
        telNo: "Telephone number must be exactly 8 digits",
        faxNo: "Fax number must be exactly 8 digits",
    },
};

export default Form033EN;
